module.exports = __webpack_public_path__ + "img/icon_reserv_fav_on.3df3d1d5.svg";